// Fuente única de verdad para slugs <-> nombre de categoría del Blog.
// SubheaderBlog.vue construye el menú a partir de estos arrays; BlogCategory.vue
// resuelve el <h1>/meta a partir del mismo slug, para que ambos usen siempre el
// mismo idioma en vez de depender de los tags que devuelve Ghost.

export const parentCategories = [
    { slug: "productos", nameKey: "blog.categories.productos" },
    { slug: "maternidad", nameKey: "blog.categories.maternidad" },
    { slug: "listas-de-ejemplo", nameKey: "blog.categories.listasDeEjemplo" },
];

export const maternityCategories = [
    { slug: "babyshower", nameKey: "blog.categories.babyshower" },
    { slug: "crianza", nameKey: "blog.categories.crianza" },
    { slug: "embarazo", nameKey: "blog.categories.embarazo" },
    { slug: "preparandose-para-el-bebe", nameKey: "blog.categories.preparandoseParaElBebe" },
];

export const productsCategories = [
    { slug: "a-jugar", nameKey: "blog.categories.aJugar" },
    { slug: "alimentacion", nameKey: "blog.categories.alimentacion" },
    { slug: "bano", nameKey: "blog.categories.bano" },
    { slug: "carritos", nameKey: "blog.categories.carritos" },
    { slug: "cunas", nameKey: "blog.categories.cunas" },
    { slug: "de-viaje", nameKey: "blog.categories.deViaje" },
    { slug: "hogar", nameKey: "blog.categories.hogar" },
    { slug: "lactancia", nameKey: "blog.categories.lactancia" },
    { slug: "libros", nameKey: "blog.categories.libros" },
    { slug: "lo-que-mas-nos-gusta", nameKey: "blog.categories.loQueMasNosGusta" },
    { slug: "panales", nameKey: "blog.categories.panales" },
    { slug: "para-mama", nameKey: "blog.categories.paraMama" },
    { slug: "portabebes", nameKey: "blog.categories.portabebes" },
    { slug: "ropa", nameKey: "blog.categories.ropa" },
    { slug: "sillas-de-coche", nameKey: "blog.categories.sillasDeCoche" },
];

export const allBlogCategories = [
    ...parentCategories,
    ...maternityCategories,
    ...productsCategories,
];

export function findBlogCategoryNameKey(slug) {
    return allBlogCategories.find((category) => category.slug === slug)?.nameKey;
}
